import {placementsService} from 'services';

export const SET_CURRENT_PLACEMENT_ID = 'SET_CURRENT_PLACEMENT_ID';
export const SET_CURRENT_PLACEMENT = 'SET_CURRENT_PLACEMENT';
export const SET_PLACEMENT_TYPES_LIST = 'SET_PLACEMENT_TYPES_LIST';
export const FETCH_PLACEMENT_TYPES = 'FETCH_PLACEMENT_TYPES';

const YANDEX_MKB_PLACEMENT_TYPES = ['YANDEX_MCBANNER_CAMPAIGN', 'YANDEX_SMART_BANNER_CAMPAIGN', 'YANDEX_UNDEFINED_CAMPAIGN'];

const UNSUPPORTED_BALANCING_PLACEMENT_TYPES = new Set([
  ...YANDEX_MKB_PLACEMENT_TYPES,
  'OZON_PAY_PER_ORDER'
]);

const placementsStore = {
  namespaced: true,
  state () {
    return {
      currentPlacement: null,
      placementTypesList: []
    };
  },
  getters: {
    currentPlacement: state => state.currentPlacement,
    placementTypesList: state => state.placementTypesList,
    balancingUnsupportedPlacementTypes: (state, getters, rootState, rootGetters) =>
      rootGetters['enums/placementTypes'].filter(i => UNSUPPORTED_BALANCING_PLACEMENT_TYPES.has(i.id)),
    bidmanagerUnsupportedPlacementsTypes: () => YANDEX_MKB_PLACEMENT_TYPES
  },
  mutations: {
    [SET_CURRENT_PLACEMENT] (state, placement) {
      state.currentPlacement = placement;
    },
    [SET_PLACEMENT_TYPES_LIST] (state, placementTypesList) {
      state.placementTypesList = placementTypesList;
    }
  },
  actions: {
    async [SET_CURRENT_PLACEMENT_ID] (context, placementId) {
      if (!placementId) {
        context.commit(SET_CURRENT_PLACEMENT, null);
        return;
      }
      const placement = await placementsService.get(context.rootGetters['accounts/currentAccountId'], placementId);
      context.commit(SET_CURRENT_PLACEMENT, placement);
    },
    async [FETCH_PLACEMENT_TYPES] (context, {force = false} = {}) {
      if (context.getters.placementTypesList.length && !force) {
        return context.getters.placementTypesList;
      }

      const placementTypes = await placementsService.getPlacementTypesFromRepos();
      context.commit(SET_PLACEMENT_TYPES_LIST, placementTypes);
      return placementTypes;
    }
  }
};

export default placementsStore;
